import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import Accordion from '../../../../components/Accordion/Accordion';
import AjudaRapida from '../../../../components/AjudaRapida/AjudaRapida';
import VisualizarDocumento from '../../../CarteiraDocumentos/VisualizarDocumento/VisualizarDocumento';
import {
  CarteiraDocumentosState,
  selectCarteiraDocumentosState,
  irParaVisualizarDocumento,
  voltarParaLista,
} from '../../../CarteiraDocumentos/carteiraDocumentosSlice';
import { selectPessoa } from '../../consultaCompletaSlice';
import styles from './CarteiraDocumentos.module.css';

const documentoDescricao: Record<number, { titulo: string; subtitulo: string }> = {
  1: { titulo: 'CIN', subtitulo: 'Carteira de Identidade Nacional' },
  2: { titulo: 'CNH', subtitulo: 'Carteira Nacional de Habilitação' },
  3: { titulo: 'Título', subtitulo: 'Título de Eleitor' },
};

const CarteiraDocumentos: React.FC = () => {
  const dispatch = useAppDispatch();
  const subState = useAppSelector(selectCarteiraDocumentosState);
  const pessoa = useAppSelector(selectPessoa);

  useEffect(() => {
    return () => { dispatch(voltarParaLista()); };
  }, [dispatch]);

  const dadosCadastro = pessoa?.pessoaDadosCadastroDTO;
  const carteiraDocumentos = pessoa?.carteiraDocumentos;

  const nomePessoa =
    dadosCadastro?.temIdentidadeGenero === 1 && dadosCadastro?.nomeSocialApelidoPessoa
      ? dadosCadastro.nomeSocialApelidoPessoa
      : dadosCadastro?.nomePessoa;

  const documentosPossuidos = carteiraDocumentos?.documentos ?? [];
  const estadoCadastralCodigo = dadosCadastro?.tipoEstadoCadastralMembro?.codigo;

  const MENSAGENS_ESTADO_CADASTRAL: Record<number, string> = {
    1: 'Carteira de Documentos não disponível. Pessoa em cadastramento. O Responsável Familiar deve procurar o posto de atendimento do Cadastro Único.',
    2: 'Carteira de Documentos não disponível. Pessoa sem registro civil. O Responsável Familiar deve procurar o posto de atendimento do Cadastro Único.',
    7: 'Carteira de Documentos não disponível. Pessoa aguardando CPF. O Responsável Familiar deve procurar o posto de atendimento do Cadastro Único.',
  };

  const temObito = !!carteiraDocumentos?.indicativoMorte;
  const mensagemBloqueio = estadoCadastralCodigo ? MENSAGENS_ESTADO_CADASTRAL[estadoCadastralCodigo] : undefined;
  const MENSAGEM_OBITO = 'Carteira de Documentos não disponível. Pessoa com registro de falecimento. O Responsável Familiar deve procurar o posto de atendimento do Cadastro Único.';

  const handleVisualizar = (doc: any, info: { titulo: string; subtitulo: string } | undefined) => {
    dispatch(irParaVisualizarDocumento({
      integranteNome: nomePessoa ?? '',
      tipoDocumento: String(doc.tipoDocumento.codigo),
      nomeDocumento: info ? `${info.titulo} - ${info.subtitulo}` : doc.tipoDocumento.descricao,
      dataEnvio: doc.dataEnvio ?? '',
      referenciaDocumento: doc.referenciaDocumento ?? '',
      idDocumento: doc.id ?? 0,
    }));
  };

  if (subState === CarteiraDocumentosState.VISUALIZAR_DOCUMENTO) {
    return (
      <div className={styles.visualizarWrapper}>
        <VisualizarDocumento ocultarExcluir />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Accordion
        id="carteira-documentos-pessoa"
        title={nomePessoa}
        open
        className={styles.accordionNome}
      >
        <div className={styles.documentosContainer}>
          {temObito && documentosPossuidos.length === 0 ? (
            <p className={styles.semDocumentos}>{MENSAGEM_OBITO}</p>
          ) : mensagemBloqueio ? (
            <p className={styles.semDocumentos}>{mensagemBloqueio}</p>
          ) : documentosPossuidos.length > 0 ? (
            documentosPossuidos.map((doc: any, index: number) => {
              const info = documentoDescricao[doc.tipoDocumento.codigo];
              return (
                <div key={index} className={styles.documentoItem}>
                  <div className={styles.documentoInfo}>
                    <span className={styles.documentoTitulo}>{info?.titulo ?? doc.tipoDocumento.descricao}</span>
                    <span className={styles.documentoSubtitulo}>{info?.subtitulo ?? ''}</span>
                  </div>
                  <div className={styles.documentoActions}>
                    <button className={`${styles.documentoButton} ${styles.hasDocument}`} onClick={() => handleVisualizar(doc, info)}>
                      <i className="fas fa-eye"></i>
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <p className={styles.semDocumentos}>Nenhum documento biométrico na Carteira de Documentos deste integrante familiar.</p>
          )}
        </div>
      </Accordion>

      <div className={styles.ajudaRapidaContainer}>
        <AjudaRapida>
          O Responsável Familiar (RF) pode guardar <b>documentos biométricos digitais</b> na <b>carteira de documentos</b> dos integrantes da sua família.
          <p>
            <br />
            São aceitos:
            <br />&nbsp;- CIN (Carteira de Identidade Nacional);
            <br />&nbsp;- CNH (Carteira Nacional de Habilitação);
            <br />&nbsp;- Título (Título de Eleitor).
          </p>
          <p>
            Assim, não será mais necessária a apresentação destes documentos no atendimento presencial.
          </p>
        </AjudaRapida>
      </div>
    </div>
  );
};

export default CarteiraDocumentos;
